/**
 * Admin Dashboard Entry Point
 */

import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "./index.css"

// Add global error handling
window.addEventListener("error", (event) => {
  console.error("Global error:", event.error)
})

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason)
})

const rootElement = document.getElementById("root")

if (!rootElement) {
  console.error("Root element not found")
  document.body.innerHTML =
    '<div style="padding: 2rem; text-align: center;"><h1>Error: Root element not found</h1></div>'
} else {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  } catch (error) {
    console.error("Failed to render app:", error)
    rootElement.innerHTML = `
			<div style="padding: 2rem; text-align: center; color: red;">
				<h1>Failed to load application</h1>
				<p>Check console for details</p>
				<pre style="text-align: left; background: #f5f5f5; padding: 1rem; border-radius: 4px;">${error instanceof Error ? error.message : String(error)}</pre>
			</div>
		`
  }
}
